import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import { CookiesProvider } from "react-cookie";
import PageWrapper from "./components/PageWrapper";
import "./styles/global.module.scss";
ReactDOM.render(_jsx(CookiesProvider, { children: _jsx(PageWrapper, {}, void 0) }, void 0), document.getElementById("root"));
